import React, { Component } from 'react';
import classNames from 'classnames';
import IconComponent from '../../iconComponent';
import styles from './style.scss';

export default class MenuItem extends Component {

    menuItemHover = () => {

        this.refs.menuItem.children[0].className = this.refs.menuItem.children[0].className + ' hover-icon';
    }

    menuItemOut = () => {

        this.refs.menuItem.children[0].className = this.refs.menuItem.children[0].className.replace(' hover-icon', '');
    }

    render() {

        if (this.props.isSelected === true) {
            return (
                <li className={classNames(['item-selected'])}>
                    <IconComponent iconClassName={classNames(this.props.iconClassName + styles.hoverIcon)} />
                </li>
            );
        }

        return (
            <li className={classNames(this.props.isSelected && ['item-selected'])}
                onMouseOver={this.menuItemHover}
                onMouseOut={this.menuItemOut} ref='menuItem'>
                <IconComponent iconClassName={classNames(this.props.iconClassName)} />
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/controls/sidebar/menuItem.jsx